// // 安全分析报告---车辆分析报告
// const reportsVehicleSecurity = (resolve) => {
//   import('components/reports/reports.securityVehicle').then((module) => {
//     resolve(module)
//   })
// }
// // 安全分析报告---车辆分析报告详情
// const reportsVehicleSecurityDetail = (resolve) => {
//   import('components/reports/reports.securityVehicle_detail').then((module) => {
//     resolve(module)
//   })
// }
// 常用报表---里程汇总报表
const reportsNormalSummery = (resolve) => {
  import('components/reports/reports.normalSummery').then((module) => {
    resolve(module)
  })
}

// 常用报表---里程日报表
const reportsNormalDetail = (resolve) => {
  import('components/reports/reports.normalDetail').then((module) => {
    resolve(module)
  })
}

// 上下线报表---上线率报表
const reportsOnline = (resolve) => {
  import('components/reports/reports.onofflineRate').then((module) => {
    resolve(module)
  })
}

// 上下线报表---上下线汇总表
const reportsOnoffSummery = (resolve) => {
  import('components/reports/reports.onofflineSummery').then((module) => {
    resolve(module)
  })
}

// 上下线报表---上下线明细表
const reportsOnoffDetail = (resolve) => {
  import('components/reports/reports.onofflineDetail').then((module) => {
    resolve(module)
  })
}

// IO输入报警报表---IO输入报警汇总报表
const reportsIoSummery = (resolve) => {
  import('components/reports/reports.IoSummery').then((module) => {
    resolve(module)
  })
}

// IO输入报警报表---IO输入报警明细报表
const reportsIoDetail = (resolve) => {
  import('components/reports/reports.IoDetail').then((module) => {
    resolve(module)
  })
}

// 报警报表---报警汇总报表
const reportsAlarmSummery = (resolve) => {
  import('components/reports/reports.AlarmSummery').then((module) => {
    resolve(module)
  })
}

// 报警报表---乘客超员记录表
const reportsPassengerOvercrowding = (resolve) => {
  import('components/reports/reports.PassengerOvercrowding').then((module) => {
    resolve(module)
  })
}

// 报警报表---报警报表
const reportsAlarmDetail = (resolve) => {
  import('components/reports/reports.AlarmDetail').then((module) => {
    resolve(module)
  })
}

// 客流统计---客流量统计
const reportsTrafficSummery = (resolve) => {
  import('components/reports/reports.TrafficSummery').then((module) => {
    resolve(module)
  })
}

// 客流统计---客流量查询
const reportsTrafficQuery = (resolve) => {
  import('components/reports/reports.TrafficQuery').then((module) => {
    resolve(module)
  })
}
// 客流统计---客流量统计-过标专用
const reportsTrafficSummeryNew = (resolve) => {
  import('components/reports/reports.TrafficSummeryNew').then((module) => {
    resolve(module)
  })
}

// 存储介质报表---存储介质报警明细表
const reportsNavAlarmDiskerror = (resolve) => {
  import('components/reports/reports.NavAlarmDiskerror').then((module) => {
    resolve(module)
  })
}
// 存储介质报表---硬盘超温报警明细表
const reportsNavAlarmHighTemperature = (resolve) => {
  import('components/reports/reports.NavAlarmHighTemperature').then((module) => {
    resolve(module)
  })
}
// 存储介质报表---硬盘状态信息明细表
const reportsNavAlarmInformationDetail = (resolve) => {
  import('components/reports/reports.NavAlarmInformationDetail').then((module) => {
    resolve(module)
  })
}

// 设备升级报表---车辆版本明细表
const reportsVehicleReleaseDetails = (resolve) => {
  import('components/reports/reports.VehicleReleaseDetails').then((module) => {
    resolve(module)
  })
}
// 设备升级报表---设备离线升级记录报表
const reportsVehicleRecordingUpgrade = (resolve) => {
  import('components/reports/reports.VehicleRecordingUpgrade').then((module) => {
    resolve(module)
  })
}
// 设备升级报表---参数配置报表
const reportsVehicleConfiguration = (resolve) => {
  import('components/reports/reports.VehicleConfiguration').then((module) => {
    resolve(module)
  })
}
// 设备升级报表---车辆MCU报表
const reportsVehicleMCUDetails = (resolve) => {
  import('components/reports/reports.VehicleMCUDetails').then((module) => {
    resolve(module)
  })
}
// 设备升级报表---车辆IPC报表
// const reportsVehicleIPCDetails = (resolve) => {
//   import('components/reports/reports.VehicleIPCDetails').then((module) => {
//     resolve(module)
//   })
// }

// 油量报表-油量动态明细表
const reportsOilDynamicDetail = (resolve) => {
  import('components/reports/reports.OilDynamicDetail').then((module) => {
    resolve(module)
  })
}
// 油量报表-油量异常明细表
const reportsOilUnusualDetail = (resolve) => {
  import('components/reports/reports.OilUnusualDetail').then((module) => {
    resolve(module)
  })
}
// 油量报表-油量日统计表
const reportsOilDaily = (resolve) => {
  import('components/reports/reports.OilDaily').then((module) => {
    resolve(module)
  })
}

// 停车报表-停车未熄火汇总表
const reportsParkingNSDSummery = (resolve) => {
  import('components/reports/reports.ParkingNSDSummery').then((module) => {
    resolve(module)
  })
}
// 停车报表-停车未熄火明细表
const reportsParkingNSDdetail = (resolve) => {
  import('components/reports/reports.ParkingNSDdetail').then((module) => {
    resolve(module)
  })
}
// 停车报表-超时停车汇总表
const reportsParkingOvertimeSummery = (resolve) => {
  import('components/reports/reports.ParkingOvertimeSummery').then((module) => {
    resolve(module)
  })
}
// 停车报表-超时停车明细表
const reportsParkingOvertimeDetail = (resolve) => {
  import('components/reports/reports.ParkingOvertimeDetail').then((module) => {
    resolve(module)
  })
}

// 电子围栏-围栏报警明细表
const reportsFenceDetail = (resolve) => {
  import('components/reports/reports.FenceDetail').then((module) => {
    resolve(module)
  })
}

// 调度报表-TTS明细表
const reportsTTSDetail = (resolve) => {
  import('components/reports/reports.TTSDetail').then((module) => {
    resolve(module)
  })
}

// 胎压报表-胎压传感器明细表
const reportsTyreDetail = (resolve) => {
  import('components/reports/reports.TyreDetail').then((module) => {
    resolve(module)
  })
}

// 外设报表-学生统计报表
const reportsStudentCount = (resolve) => {
  import('components/reports/reports.studentCount').then((module) => {
    resolve(module)
  })
}

// 多媒体-图片
const reportsMultimideaPicture = (resolve) => {
  import('components/reports/reports.MultimideaPicture').then((module) => {
    resolve(module)
  })
}
// 多媒体-音频
const reportsMultimideaAudio = (resolve) => {
  import('components/reports/reports.MultimideaAudio').then((module) => {
    resolve(module)
  })
}
// 多媒体-视频
const reportsMultimideaVideo = (resolve) => {
  import('components/reports/reports.MultimideaVideo').then((module) => {
    resolve(module)
  })
}
// 音视频资源文件-音视频资源明细报表
const reportsVideoDetail = (resolve) => {
  import('components/reports/reports.VideoDetail').then((module) => {
    resolve(module)
  })
}
// 音视频资源文件-音视频资源汇总报表
const reportsVideoSummery = (resolve) => {
  import('components/reports/reports.VideoSummery').then((module) => {
    resolve(module)
  })
}

// 历史轨迹
const ValidHistoryTrace = (resolve) => {
  import('components/reports/reports.ValidHistoryTrace').then((module) => {
    resolve(module)
  })
}
// obd
const OBDdetail = (resolve) => {
  import('components/reports/reports.OBDdetail').then((module) => {
    resolve(module)
  })
}
// 行驶记录管理
const drivingrecord = (resolve) => {
  import('components/reports/reports.drivingrecord').then((module) => {
    resolve(module)
  })
}
// ETC记录管理
const etcrecord = (resolve) => {
  import('components/reports/reports.etcCardInfoDtl').then((module) => {
    resolve(module)
  })
}
// ETC交易记录管理
const etcBillrecord = (resolve) => {
  import('components/reports/reports.etcTransactionBillDtl').then((module) => {
    resolve(module)
  })
}
// ETC报警管理
const etcAlarmInfo = (resolve) => {
  import('components/reports/reports.etcAlarmInfo').then((module) => {
    resolve(module)
  })
}
// iccid
const iccid = (resolve) => {
  import('components/reports/reports.Iccid').then((module) => {
    resolve(module)
  })
}
// 中俄交互系统---数据交互数目
const dataTransmissionInfocount = (resolve) => {
  import('components/reports/reports.dataTransmissionInfo').then((module) => {
    resolve(module)
  })
}
// 中俄交互系统---进入中方的车辆数目
const dataTransmissionInfoToChinacount = (resolve) => {
  import('components/reports/reports.dataTransInfoToChina').then((module) => {
    resolve(module)
  })
}
// 中俄交互系统---进入俄方的车辆数目
const dataTransmissionInfoToRussiacount = (resolve) => {
  import('components/reports/reports.dataTransInfoToRussia').then((module) => {
    resolve(module)
  })
}
// 中俄交互系统---进入中方的车辆数目
const dataTransmissionInfoEx = (resolve) => {
  import('components/reports/reports.dataTransInfoEx').then((module) => {
    resolve(module)
  })
}

// 未打表报警
const notPlaying = (resolve) => {
  import('components/reports/reports.notPlaying.vue').then((module) => {
    resolve(module)
  })
}
// 信号干扰报警
const signalDisturbDatail = (resolve) => {
  import('components/reports/reports.signalDisturbDatail.vue').then((module) => {
    resolve(module)
  })
}
// 沉船报警
const wreckDatail = (resolve) => {
  import('components/reports/reports.wreckDatail.vue').then((module) => {
    resolve(module)
  })
}
// 防拆卸报警
const antiDisassemblyDatail = (resolve) => {
  import('components/reports/reports.antiDisassemblyDatail.vue').then((module) => {
    resolve(module)
  })
}
// 温度报表
const temperature = (resolve) => {
  import('components/reports/reports.temperature.vue').then((module) => {
    resolve(module)
  })
}
// 行驶时长明细
const travelTimeDetail = (resolve) => {
  import('components/reports/reports.travelTimeDetail.vue').then((module) => {
    resolve(module)
  })
}
// 行驶时长汇总
const travelTimeSummery = (resolve) => {
  import('components/reports/reports.travelTimeSummery.vue').then((module) => {
    resolve(module)
  })
}
// 物流锁-操作记录
const operationRecord = (resolve) => {
  import('components/reports/reports.OperationRecord.vue').then((module) => {
    resolve(module)
  })
}
// 物流锁-报警记录
const alarmRecord = (resolve) => {
  import('components/reports/reports.alarmRecord').then((module) => {
    resolve(module)
  })
}

const reportRouter = {
  reportPath: [{
    path: '/reports/normalSummery', // 里程汇总报表(常用报表)
    component: reportsNormalSummery
  },
  {
    path: '/reports/normalDetail', // 里程日报表(常用报表)
    component: reportsNormalDetail
  },
  {
    path: '/reports/onofflinerate', // 上线率报表(上下线报表)
    component: reportsOnline
  },
  {
    path: '/reports/reportsOnoffSummery', // 上下线汇总报表(上下线报表)
    component: reportsOnoffSummery
  },
  {
    path: '/reports/reportsOnoffDetail', // 上下线明细报表(上下线报表)
    component: reportsOnoffDetail
  },
  {
    path: '/reports/IoSummery', // IO输入报警汇总报表(IO输入报警报表)
    component: reportsIoSummery
  },
  {
    path: '/reports/IoDetail', // IO输入报警明细报表(IO输入报警报表)
    component: reportsIoDetail
  },
  {
    path: '/reports/AlarmSummery', // 报警汇总报表(报警报表)
    component: reportsAlarmSummery
  },
  {
    path: '/reports/PassengerOvercrowding', // 报警汇总报表(乘客超员记录表)
    component: reportsPassengerOvercrowding
  },
  {
    path: '/reports/AlarmDetail', // 报警报表(报警报表)
    component: reportsAlarmDetail
  },
  {
    path: '/reports/TrafficSummery', // 客流量统计(客流统计)
    component: reportsTrafficSummery
  },
  {
    path: '/reports/TrafficQuery', // 客流量查询(客流统计)
    component: reportsTrafficQuery
  },
  {
    path: '/reports/TrafficSummeryNew', // 客流量统计(客流统计)
    component: reportsTrafficSummeryNew
  },
  {
    path: '/reports/NavAlarmDiskerror', // 存储介质报警明细表(存储介质报表)
    component: reportsNavAlarmDiskerror
  },
  {
    path: '/reports/NavAlarmHighTemperature', // 硬盘超温报警明细表(存储介质报表)
    component: reportsNavAlarmHighTemperature
  },
  {
    path: '/reports/NavAlarmInformationDetail', // 硬盘超温报警明细表(存储介质报表)
    component: reportsNavAlarmInformationDetail
  },
  {
    path: '/reports/VehicleReleaseDetails', // 车辆版本明细表(设备升级报表)
    component: reportsVehicleReleaseDetails
  },
  {
    path: '/reports/VehicleRecordingUpgrade', // 设备离线升级记录报表(设备升级报表)
    component: reportsVehicleRecordingUpgrade
  },
  {
    path: '/reports/VehicleConfiguration', // 参数配置报表(设备升级报表)
    component: reportsVehicleConfiguration
  },
  {
    path: '/reports/VehicleMCUDetails', // 车辆MCU报表(设备升级报表)
    component: reportsVehicleMCUDetails
  },
  // {
  //   path: '/reports/VehicleIPCDetails', // 车辆IPC报表(设备升级报表)
  //   component: reportsVehicleIPCDetails
  // },
  {
    path: '/reports/OilDynamicDetail', // 油量动态明细表(油量报表)
    component: reportsOilDynamicDetail
  },
  {
    path: '/reports/OilUnusualDetail', // 油量异常明细表(油量报表)
    component: reportsOilUnusualDetail
  },
  {
    path: '/reports/OilDaily', // 油量日统计表(油量报表)
    component: reportsOilDaily
  },
  {
    path: '/reports/ParkingNSDSummery', // 停车未熄火汇总表(停车报表)
    component: reportsParkingNSDSummery
  },
  {
    path: '/reports/ParkingNSDdetail', // 停车未熄火明细表(停车报表)
    component: reportsParkingNSDdetail
  },
  {
    path: '/reports/ParkingOvertimeSummery', // 超时停车汇总表(停车报表)
    component: reportsParkingOvertimeSummery
  },
  {
    path: '/reports/ParkingOvertimeDetail', // 超时停车明细表(停车报表)
    component: reportsParkingOvertimeDetail
  },
  {
    path: '/reports/FenceDetail', // 围栏报警明细表(电子围栏)
    component: reportsFenceDetail
  },
  {
    path: '/reports/TTSDetail', // TTS明细表(调度报表)
    component: reportsTTSDetail
  },
  {
    path: '/reports/TyreDetail', // 胎压传感器明细表(胎压报表)
    component: reportsTyreDetail
  },
  {
    path: '/reports/studentCount', // 学生统计报表
    component: reportsStudentCount
  },
  {
    path: '/reports/MultimideaPicture', // 图片(多媒体)
    component: reportsMultimideaPicture
  },
  {
    path: '/reports/MultimideaAudio', // 音频(多媒体)
    component: reportsMultimideaAudio
  },
  {
    path: '/reports/MultimideaVideo', // 视频(多媒体)
    component: reportsMultimideaVideo
  },
  {
    path: '/reports/VideoDetail', // 音视频资源明细报表(音视频资源文件)
    component: reportsVideoDetail
  },
  {
    path: '/reports/VideoSummery', // 音视频资源汇总报表(音视频资源文件)
    component: reportsVideoSummery
  },
  {
    path: '/reports/ValidHistoryTrace', // 历史轨迹
    component: ValidHistoryTrace
  },
  {
    path: '/reports/OBDdetail', // obd
    component: OBDdetail
  },
  {
    path: '/reports/drivingrecord', // 行驶记录管理
    component: drivingrecord
  },
  {
    path: '/reports/etcCardInfoDtl', // ETC记录管理
    component: etcrecord
  },
  {
    path: '/reports/etcTransactionBillDtl', // ETC交易记录管理
    component: etcBillrecord
  },
  {
    path: '/reports/etcAlarmInfo', // ETC报警管理
    component: etcAlarmInfo
  },
  {
    path: '/reports/iccid', // iccid
    component: iccid
  },
  {
    path: '/dataTransInfo/list', // 俄罗斯数据传输系统数目
    component: dataTransmissionInfocount
  },
  {
    path: '/dataTransInfo/toChina', // 中俄交互系统---进入中方的车辆数目
    component: dataTransmissionInfoToChinacount
  },
  {
    path: '/dataTransInfo/toRussia', // 中俄交互系统---进入俄方的车辆数目
    component: dataTransmissionInfoToRussiacount
  },
  {
    path: '/dataTransInfo/dataTransInfoEx', // 中俄交互系统---数据包
    component: dataTransmissionInfoEx
  },
  {
    path: '/reports/notPlaying', // 未打表
    component: notPlaying
  },
  {
    path: '/reports/signalDisturbDatail', // 信号干扰报警
    component: signalDisturbDatail
  },
  {
    path: '/reports/wreckDatail', // 沉船报警
    component: wreckDatail
  },
  {
    path: '/reports/antiDisassemblyDatail', // 防拆卸报警
    component: antiDisassemblyDatail
  },
  {
    path: '/reports/temperature', // 温度报表
    component: temperature
  },
  {
    path: '/reports/travelTimeDetail', // 行驶时长明细
    component: travelTimeDetail
  },
  {
    path: '/reports/travelTimeSummery', // 行驶时长汇总
    component: travelTimeSummery
  },
  {
    path: '/reports/operationRecord', // 物流锁-操作记录
    component: operationRecord
  },
  {
    path: '/reports/alarmRecord', // 物流锁-报警记录
    component: alarmRecord
  }
  ]
}

export default reportRouter



// WEBPACK FOOTER //
// ./src/router/report.js